import { SEC_ApiCall, SEC_DataApiPost } from '../func.js';

/** Validate a learner administration response before the UI consumes it. */
function ensureValidResponse(response, validator, fallbackMessage) {
    if (!response || typeof response !== 'object') {
        throw new Error(fallbackMessage);
    }
    if (typeof response.message === 'string' && response.message) {
        throw new Error(response.message);
    }
    if (!validator(response)) {
        throw new Error(response.error || fallbackMessage);
    }
    return response;
}

/** Load learners visible to the authenticated learner administrator. */
export async function getSysManagerLearners(includeArchived = false) {
    const response = await SEC_ApiCall('sysmanager/learners', {
        includeArchived: includeArchived ? 'true' : 'false',
    });
    return ensureValidResponse(
        response,
        (payload) => Array.isArray(payload.items),
        'Unexpected learner list response.',
    );
}

/** Check Wonde learner-sync availability and optionally load the five latest runs. */
export async function getLearnerSyncResults(summaryOnly = false) {
    const response = await SEC_ApiCall('sysmanager/learners/sync-results', {
        summaryOnly: summaryOnly ? 'true' : 'false',
        syncType: 'LEARNERS',
    });
    return ensureValidResponse(
        response,
        (payload) => (
            typeof payload.enabled === 'boolean'
            && (summaryOnly || Array.isArray(payload.items))
        ),
        'Unexpected learner sync results response.',
    );
}

/** Load safe error details for one learner or staff sync run. */
export async function getSyncErrorDetails(logId) {
    const response = await SEC_ApiCall('sysmanager/learners/sync-results', {
        logId,
        syncType: 'LEARNERS',
    });
    return ensureValidResponse(
        response,
        (payload) => typeof payload.enabled === 'boolean' && Array.isArray(payload.items),
        'Unexpected sync error details response.',
    );
}

/** Update one ALN, MTT or FSM value for one active pupil. */
export async function updateSysManagerLearnerFlag(payload) {
    const response = await SEC_DataApiPost(
        'sysmanager/learners/update',
        JSON.stringify(payload),
        {},
    );
    return ensureValidResponse(
        response,
        (responsePayload) => (
            responsePayload.updated === true
            && typeof responsePayload.pupilId === 'string'
            && ['ALN', 'MTT', 'FSM'].includes(responsePayload.field)
            && typeof responsePayload.value === 'boolean'
        ),
        'Unexpected learner update response.',
    );
}
